// extracted by mini-css-extract-plugin
export default {"rhelper":"LimitedTextarea_rhelper__yJQ4a","enough":"LimitedTextarea_enough__ze+hn","errorMessage":"LimitedTextarea_errorMessage__OEvCC"};